import { call, put } from 'redux-saga/effects';
import { api, notify } from 'services';
import { requestErrorHandler } from 'utils';
import {
  FetchVaccineCertificatesActions,
  FetchVaccineCertificatesRequest,
} from 'store/ducks/drivers';

export function* fetchVaccineCertificates(action: any) {
  const { id, onSuccess }: FetchVaccineCertificatesRequest = action;

  try {
    const { data } = yield call(api.get, `/vaccine/driver-certificates/${id}`);
    onSuccess && onSuccess(data);
    yield put(FetchVaccineCertificatesActions.success(data));
  } catch (error) {
    const { errorMessage, validationErrors } = requestErrorHandler(error);

    notify('error', errorMessage);

    yield put(
      FetchVaccineCertificatesActions.failure(errorMessage, validationErrors)
    );
  }
}
